export default "__VITE_ASSET__DPPzRiSR__"